import { FormattedMessage } from 'react-intl';

const prefix = 'pageNotFoundErrorPage';
export function PageNotFoundErrorPage() {
  const header = <FormattedMessage id={`${prefix}.errorMessage`} defaultMessage="Page Not Found" />;
  const subheader = (
    <FormattedMessage
      id={`${prefix}.errorDescription`}
      defaultMessage="Sorry, the page you're looking for doesn't exist or has been removed."
    />
  );
  const image = '/dino-zenner.png';

  return (
    <div className="view-error-page">
      <div className="ui hidden divider"></div>
      <div className="custom-header mark">{header}</div>
      <div className="description">
        <p> {subheader}</p>
      </div>
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered huge image error-image" src={image} alt="unlink" />
        </div>
      </div>
    </div>
  );
}
